module.exports = __webpack_public_path__ + "img/ea89c1f.png";